import * as types from './types';

import produce from 'immer';

const initialState = {
  projectList: [],
  engagementList: [],
  selectedEngagementId: null,
  selectedProjectId: null,
  message: 'default message'
};

const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case types.CREATE_ENGAGEMENT_SUCCESS: {
        draft.engagementList.push(action.payload);
        draft.selectedEngagementId = action.payload.engagementId;
        draft.selectedProjectId = null;
        break;
      }
      case types.CREATE_PROJECT_SUCCESS: {
        draft.projectList.push(action.payload);
        draft.selectedProjectId = action.payload.projectId;
        draft.selectedEngagementId = null;
        break;
      }
      case types.EDIT_ENGAGEMENT_SUCCESS: {
        const index = draft.engagementList.findIndex(
          each => each.engagementId === action.payload.engagementId
        );
        draft.engagementList[index] = action.payload;
        break;
      }
      case types.EDIT_PROJECT_SUCCESS: {
        const index = draft.projectList.findIndex(
          each => each.projectId === action.payload.projectId
        );
        draft.projectList[index] = action.payload;
        break;
      }
      case types.DELETE_ENGAGEMENT_SUCCESS: {
        const index = draft.engagementList.findIndex(
          each => each.engagementId === action.meta.engagementId
        );
        draft.engagementList.splice(index, 1);
        draft.selectedEngagementId = null;
        break;
      }
      case types.DELETE_PROJECT_SUCCESS: {
        const index = draft.projectList.findIndex(
          each => each.projectId === action.meta.projectId
        );
        draft.projectList.splice(index, 1);
        draft.selectedProjectId = null;
        break;
      }
      case types.GET_PROJECTS_SUCCESS: {
        draft.projectList = action.payload.projects;
        draft.engagementList = action.payload.engagements.map(each => ({
          ...each,
          open: true
        }));
        draft.selectedProjectId = null;
        break;
      }
      case types.SELECT_ENGAGEMENT: {
        draft.engagementList = draft.engagementList.map(engagement => {
          if (engagement.engagementId === action.engagementId) {
            if (state.selectedEngagementId === engagement.engagementId) {
              engagement.open = !engagement.open;
            } else {
              engagement.open = true;
              draft.selectedEngagementId = engagement.engagementId;
              draft.selectedProjectId = null;
            }
          }
          return engagement;
        });
        break;
      }
      case types.SELECT_PROJECT: {
        draft.selectedProjectId = action.project.projectId;
        draft.selectedEngagementId = null;
        break;
      }
      case types.SEARCH_PROJECTS: {
        if (!action.searchTerm || action.searchTerm.trim().length === 0) {
          draft.searchResults = null;
          break;
        }
        draft.searchResults = draft.projectList.filter(
          project =>
            project.projectName
              .toLowerCase()
              .indexOf(action.searchTerm.toLowerCase()) > -1
        );
        break;
      }
      default:
      // console.log('default actions');
      // draft.message = action.payload;
    }
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/projects/reducer.js